module.exports = __webpack_public_path__ + "media/images/group_insurances/cowork_banner-0b56e813af397570674e89e7341f69cb.jpg";